import { useState, useEffect } from 'react';

/**
 * Live viewport detection. Returns true when the screen is narrower than
 * `breakpoint` (default 768px = Tailwind's `md`). Updates on resize / rotate
 * via matchMedia, so the app switches between the mobile and desktop trees
 * without a reload.
 */
export default function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`;

  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false
  );

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const handler = (e) => setIsMobile(e.matches);
    setIsMobile(mql.matches);
    // Safari < 14 uses the deprecated add/removeListener API.
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else mql.addListener(handler);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', handler);
      else mql.removeListener(handler);
    };
  }, [query]);

  return isMobile;
}
